import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { generateScenarioFileUrl } from '@/utils/generateScenarioFileUrl';
import type React from 'react';
import styles from './index.module.scss';

export const COURSE_LESSON_SCENARIO_STORY_COLUMN_FRAGMENT =
  graphql(/* GraphQL */ `
  fragment EmbaCourseLessonScenarioStoryColumn on ScenarioContentColumn {
    ...on ScenarioContentColumn {
      label
      content
      image
    }
  }
`);

type ColumnProps = {
  currentStoryContent: FragmentType<
    typeof COURSE_LESSON_SCENARIO_STORY_COLUMN_FRAGMENT
  >;
  isEnableNext: boolean;
  slideToNext: () => void;
};

export const Column: React.FC<ColumnProps> = ({
  currentStoryContent,
  slideToNext,
}) => {
  const currentStoryContentData = useFragment(
    COURSE_LESSON_SCENARIO_STORY_COLUMN_FRAGMENT,
    currentStoryContent,
  );

  return (
    <div className={styles.contentArea}>
      <div className={styles.columnArea}>
        <div className={styles.columnHeader}>
          <h3 className={styles.columnHeading}>コラム</h3>
        </div>
        <div className={styles.columnSkip}>
          <button
            className="primaryShadow"
            type="button"
            onClick={() => slideToNext()}
          >
            コラムをスキップする
          </button>
        </div>
        <div className={styles.columnContent}>
          <h4>{currentStoryContentData.label}</h4>
          <p>{currentStoryContentData.content}</p>
          {currentStoryContentData.image && (
            <img
              className={styles.columnImage}
              src={generateScenarioFileUrl(
                currentStoryContentData.image,
                'column',
              )}
              alt=""
            />
          )}
        </div>
      </div>
    </div>
  );
};
